"use client";
import { useDialogs } from "@/lib/hooks/use-dialogs";
import Image from "next/image";
export const ChallengeButton = () => {
  const { openDialog } = useDialogs();

  return (
    <button
      onClick={() => openDialog("marcus-challenge")}
      className="flex md:hidden size-12 relative border-2 shrink-0 border-[#ad5dfe] rounded-xl shadow-[0px_4px_4px_0px_rgba(41,37,36,0.12)]  items-center justify-center overflow-hidden cursor-pointer"
      style={{
        backgroundImage:
          "linear-gradient(rgba(255, 255, 255, 0.56) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(90deg, rgb(129, 65, 194) 0%, rgb(129, 65, 194) 100%)",
      }}
    >
      <Image src="/icons/sparkles.svg" alt="sparkles" width={20} height={20} />
    </button>
  );
};
